import { cn } from '@/libs/tailwind';

export const Banner = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return (
    <div
      className={cn(
        'bg-orange-20 py-2 px-5 flex items-center justify-center text-orange-90 text-body-sm font-medium',
        className,
      )}
    >
      {children}
    </div>
  );
};
